import React, { useState, useEffect } from "react";
import FetchFundraisersComponents from "../../components/Warehouse/FetchFundraisers";
import ShippingTypeDisplayComponent from "../../components/Warehouse/ShippingDisplay";
import "./WarehouseOrder.css";
import { TimePeriod } from "../../Interfaces/Warehouse";
import ItemsNeeded from "../../components/Warehouse/ItemsNeeded";
import { useParams } from "react-router-dom";
import { useNavigate, useLocation } from "react-router-dom";
import AddBrochureOrder from "../../components/Warehouse/AddBrochureOrder";
import FileGenerationButtons from "../../components/Warehouse/FileGenerationButtons";
import config from "../../config";
import { ParticipantBuyout } from "../../Interfaces/Buyout";
import fetchWithAuth from "../../services/fetchWithAuth";

const WarehouseOrderPage: React.FC = () => {
  const [selectedTimePeriod, setSelectedTimePeriod] = useState<TimePeriod>(
    TimePeriod.All
  );
  const [showPopup, setShowPopup] = useState(false);
  const [loading, setLoading] = useState(true);
  const [buyoutParticipants, setBuyoutParticipants] = useState<
    ParticipantBuyout[]
  >([]);

  const handleTimePeriodChange = (
    event: React.ChangeEvent<HTMLSelectElement>
  ) => {
    setSelectedTimePeriod(event.target.value as TimePeriod);
  };
  useEffect(() => {
    const fetchParticipants = async (fundraiserId: string) => {
      try {
        const response = await fetchWithAuth(
          `${config.API_BASE_URL}buyout/${fundraiserId}/`
        );
        if (!response.ok) {
          throw new Error("Failed to fetch participants");
        }
        const data = await response.json();
        setBuyoutParticipants(data);
      } catch (error) {
        console.error("Error fetching participants:", error);
      } finally {
        setLoading(false); // Ensure loading state is updated
      }
    };

    const fetchData = async () => {
      if (fundraiserID) {
        await fetchParticipants(fundraiserID);
      } else {
        setLoading(false); // If no fundraiserID, stop loading immediately
      }
    };

    fetchData();

    document.title = "MamFam Warehouse";
  }, []);
  // Extract enum values to an array
  const timePeriodOptions = Object.values(TimePeriod);
  const { fundraiserID } = useParams<{ fundraiserID: string }>();
  const openPopup = () => setShowPopup(true);
  const closePopup = () => setShowPopup(false);

  const navigate = useNavigate();

  // Convert to number or set to 0 if not present
  const id = fundraiserID ? Number(fundraiserID) : 0;

  const viewAllPendingOrdersButtonClick = () => {
    navigate("/warehouse/orders/");
  };

  const viewAllOrdersButtonClick = () => {
    navigate("/warehouse/orders/all");
  };

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const fundraiserName = queryParams.get("fundraiserName") || "All"; // Default to "All" if not present
  const brochureAccount: number =
    Number(queryParams.get("brochureOnlyAccount")) || -1;

  return (
    <div className="warehouse-order-page-container">
      <button onClick={viewAllPendingOrdersButtonClick}>
        View all Pending Orders
      </button>
      <button onClick={viewAllOrdersButtonClick}>View All Orders</button>
      <h2 className="warehouse-page-fundraiser-header-display">
        {fundraiserName} Pending Orders
      </h2>

      {id !== 0 &&
        (brochureAccount !== -1 ? (
          <button onClick={openPopup}>Enter Brochure Orders</button>
        ) : (
          <p>This fundraiser has brochures disabled.</p>
        ))}

      <div className="warehouse-order-page-shipping">
        <div className="warehouse-order-page-item">
          <ShippingTypeDisplayComponent
            header="Ship to Home"
            order_type="home"
            fundraiser_id={id}
          />
        </div>
        <div className="warehouse-order-page-item">
          <ShippingTypeDisplayComponent
            header="Bulk Shipping"
            order_type="bulk"
            fundraiser_id={id}
          />
        </div>
      </div>
      {id !== 0 && (
        <FileGenerationButtons
          fundraiserID={id}
          fundraiserName={fundraiserName}
        />
      )}

      <div className="warehouse-order-page-fundraiser-list">
        {id === 0 && (
          <>
            <label htmlFor="timePeriodSelect">Select Time Period:</label>
            <select
              id="timePeriodSelect"
              value={selectedTimePeriod}
              onChange={handleTimePeriodChange}
            >
              {Object.entries(TimePeriod).map(([label, value]) => (
                <option key={value} value={value}>
                  {label.replaceAll("_", " ")}{" "}
                  {/* This will convert 'THREE_DAYS' to 'THREE DAYS' */}
                </option>
              ))}
            </select>

            {/* Pass the selected time period to FetchFundraisersComponents */}
            <FetchFundraisersComponents timePeriod={selectedTimePeriod} />
          </>
        )}
      </div>
      <div className="warehouse-order-page-items-needed-table">
        <ItemsNeeded fundraiser_id={id} />
      </div>
      {showPopup && (
        <AddBrochureOrder
          fundraiserID={id}
          onClose={closePopup}
          brochureOnlyAccountID={brochureAccount}
        />
      )}
    </div>
  );
};

export default WarehouseOrderPage;
